import BaseItem from '../base_item';

export default class AlienCorpse extends BaseItem {
    constructor(x, y, corpseFrame) {
        super(x, y, "actors", corpseFrame);
    }

    static get type() { return "alien_corpse"; }
    //this is width/height of collision box (attached to bottom)
    static get width() { return 21;}
    static get height() { return 8;}

    static get mass() { return 2;}

    static get description() { return "Well, now this alien is friendly enough"; }

    static get label() {
        return "alien corpse";
    }

}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/alien_corpse.js